export default __webpack_public_path__ + "static/media/hasAirConditioning.a6f32e99.png";